import {
  Box,
  Button,
  IconButtonProps,
  SvgIcon,
  Tooltip,
  Typography,
} from '@mui/material';

export interface AssistanceResponseThumbUpButtonProps extends IconButtonProps {
  responseID: string;
  shouldShowSpark?: boolean;
  onClick: () => void;
}

export function AssistanceResponseYesButton({
  responseID,
  onClick,
  shouldShowSpark = false,
  disabled = false,
  ...iconButtonProps
}: AssistanceResponseThumbUpButtonProps) {
  return (
    <Tooltip title="Like" disableInteractive>
      <Box sx={{ position: 'relative' }}>
        <Button
          disabled={disabled}
          variant={disabled ? 'contained' : 'outlined'}
          sx={{
            px: 0.5,
            py: 0.1,
            minHeight: 0,
            minWidth: 0,
            ...iconButtonProps.sx,
            textTransform: 'none',
          }}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          <Typography color="inherit" variant="caption">
            Yes
          </Typography>
        </Button>
        <SvgIcon
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          sx={{
            width: '13px',
            height: '13px',
            position: 'absolute',
            top: -4,
            right: -10,
            opacity: shouldShowSpark ? 1 : 0,
            color: 'primary.main',
          }}
        >
          <path
            d="M5.5 11L6.6 6.6L11 5.5L6.6 4.4L5.5 0L4.4 4.4L0 5.5L4.4 6.6L5.5 11Z"
            fill="primary"
          />
        </SvgIcon>
      </Box>
    </Tooltip>
  );
}
